<template>
  <div class="page page__list">
    <search-bar
      @search="onSearch"
      name="fp_pleaseman,fp_department"
      placeholder="输入报销人、部门进行查找"
      ref="searchBar"
    />
    <filter-bar @change="onSearch" :filters="filters" ref="filterBar" />
    <scroll-list @refresh="onSearch" @loadpage="onSearchNext">
      <router-link
        class="weui-cell weui-cell_access"
        v-for="item in items"
        :key="item.id"
        :to="'/oa/fee/'+item.id"
      >
        <div class="weui-cell__bd">
          <p>{{item.fp_pleaseman}} {{item.fp_class}}</p>
          <p class="list-item-muted">{{item.fp_code}}</p>
        </div>
        <div class="weui-cell__ft">
          <p v-format="'¥#,##0.00'">{{item.fp_pleaseamount}}</p>
          <span
            class="list-item-status"
            :class="{'warning':item.fp_status!='已审核'}"
          >{{item.fp_status}}</span>
        </div>
      </router-link>
    </scroll-list>
    <div class="list-footer">
      <label class="list-footer__label">合计：{{items.length}}笔</label>
      <em class="list-footer__value" v-format="'¥#,##0.00'">{{getTotal('fp_pleaseamount')}}</em>
    </div>
    <add-button to="/oa/fee_edit" />
  </div>
</template>

<script>
import SearchBar from "@/components/SearchBar.vue";
import FilterBar from "@/components/FilterBar.vue";
import ScrollList from "@/components/ScrollList.vue";
import AddButton from "@/components/button/Add.vue";
import list from "@/mixins/list.js";

export default {
  components: {
    SearchBar,
    FilterBar,
    ScrollList,
    AddButton
  },
  mixins: [list],
  data() {
    return {
      listUrl: "/api/oa/feeplease/list",
      filters: [
        {
          type: "date",
          name: "fp_date"
        },
        {
          type: "condition",
          label: "状态",
          value: -1,
          options: [
            {
              value: -1,
              label: "全部"
            },
            {
              value: 1,
              label: "待审核",
              condition: "fp_statuscode='UNAUDITED'"
            },
            {
              value: 2,
              label: "已审核",
              condition: "fp_statuscode='AUDITED'"
            }
          ]
        }
      ]
    };
  }
};
</script>